export const CostComplianceLabels = {
  costComplianceLabel: "Cost Metrics",
  commodityFilterLabel: "Commodity",
  districtFilterLabel: "District",
  vendorFilterLabel: "Supplier",
  monthFilterLabel: "Week",
};
